import * as c from 'common/constants';

/**
 * Reset filters' set
 *
 * @param {string} filtersName
 */
export const resetFilters = (filtersName) => ({
  type: c.RESET_FILTERS,
  filtersName,
});

export default resetFilters;



// WEBPACK FOOTER //
// ./src/common/actions/resetFilters.js